import { createFeatureSelector, createSelector } from '@ngrx/store';
import { getPlainInstance } from 'utils/helpers';
import { ResponseStatus } from '@certemy/common';
import { UserData } from 'services/user/user.interface';
import { Selectors as RouterSelectors } from 'features/router-state/+state/router-state.state';
import { AssignableCertificate } from 'features/employer-add-users/+state/employer-add-users.interfaces';

interface RequestState<T> {
  status: ResponseStatus;
  data: T;
}

export interface EmployerUserProfile {
  assignCertificates: EmployerUserAssignState;
  userData: UserDataState;
}

export class FilterState {
  page = 1;
  search = '';
}

export class AssignableCertificateState {
  certificates: AssignableCertificate[] = [];
  totalCount: number;
  count = 0;
  status: ResponseStatus = ResponseStatus.INITIAL;
  filters = getPlainInstance(FilterState);
}

export class EmployerUserAssignState {
  selectedCertificates: AssignableCertificate[] = [];
  availableCertificates = getPlainInstance(AssignableCertificateState);
}

export type FilterChangeEvent = Partial<FilterState>;

export class UserDataState implements RequestState<UserData> {
  status: ResponseStatus = ResponseStatus.INITIAL;
  data: UserData = null;
}

export namespace Selectors {
  export const getEmployerUserProfile = createFeatureSelector<EmployerUserProfile>('employerUserProfile');
  export const getEmployerUserAssignState = createSelector(
    getEmployerUserProfile,
    state => state.assignCertificates,
  );
  export const getUserDataState = createSelector(
    getEmployerUserProfile,
    state => state.userData,
  );
  export const getUserData = createSelector(
    getUserDataState,
    state => state.data,
  );
  export const getSelectedUserId = createSelector(
    RouterSelectors.getRouterParams,
    params => +params['userId'] || null,
  );
}
